import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { CheckCircleIcon } from "./CheckCircleIcon.js";
const SuccessCheckCircleIcon = forwardRef((props, ref) => {
  return /* @__PURE__ */ jsx(CheckCircleIcon, { htmlColor: "#ffffff", backgroundColor: "primary", ...props, ref });
});
export {
  SuccessCheckCircleIcon
};
//# sourceMappingURL=SuccessCheckCircleIcon.js.map
